import { useEffect, useMemo, useState } from 'react'
import ThankYouPage from 'routes/ThankYou'
import FailedPage from 'routes/FailedPage'
import { useFindPaymentByIdQuery } from 'store/api-slice/hooks'
import { useApp } from 'store/steps'
import { useSearchParams } from 'react-router-dom'
import NotFound from 'routes/NotFound'
import { ProcessingPage } from './ProcessingPage'

const PaymentConfirmation = () => {
    const RETRY_INTERVALS = [5000, 15000, 30000]
    const MAX_RETRIES = RETRY_INTERVALS.length

    const { language } = useApp()
    const [shouldShowPaymentDragsOn, setShouldShowPaymentDragsOn] =
        useState(false)
    const [retryCount, setRetryCount] = useState(0)

    const [queryParams] = useSearchParams()
    const paymentId = queryParams.get('paymentId')
    const { data, refetch, isError, isLoading } = useFindPaymentByIdQuery({
        _locale: language,
        paymentId: paymentId ?? '',
    })

    useEffect(() => {
        let timer: NodeJS.Timeout

        if (data && data.status) {
            if (data.status === 'pending' || data.status === 'initiated') {
                timer = setTimeout(() => {
                    setShouldShowPaymentDragsOn(true)
                }, 15000)
            }
        }

        return () => clearTimeout(timer)
    }, [data])

    useEffect(() => {
        if (data && data.status) {
            if (
                (data.status === 'pending' || data.status === 'initiated') &&
                retryCount < MAX_RETRIES
            ) {
                const interval = RETRY_INTERVALS[retryCount]

                const timer = setTimeout(() => {
                    refetch()
                    setRetryCount((state) => state + 1)
                }, interval)

                return () => clearTimeout(timer)
            }
        }
    }, [data, retryCount])

    const content = useMemo(() => {
        if (isLoading) {
            return <ProcessingPage shouldShowProcessing={false} />
        }
        if (!data || !data.status || !data.order || isError) {
            return <NotFound />
        }
        switch (data.status) {
            case 'expired':
            case 'cancelled':
            case 'rejected':
            case 'refunded':
                return <FailedPage />
            case 'completed':
                return <ThankYouPage orderData={data.order} />
            default:
                return (
                    <ProcessingPage
                        shouldShowProcessingDragsOn={shouldShowPaymentDragsOn}
                    />
                )
        }
    }, [shouldShowPaymentDragsOn, data, isLoading, isError])

    return content
}

export default PaymentConfirmation
